var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',{ref:"self",attrs:{"config":_vm.item},on:{"tap":function($event){return _vm.$emit('click', $event)},"click":function($event){return _vm.$emit('click', $event)},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }